import { convertToNumber } from './currency';

export const removeDashesInSSN = (ssn: string) => {
  return ssn.replace(/-/g, '');
};

export const createFullName = (
  firstName?: string,
  lastName?: string,
): string => {
  const first = firstName?.trim() || '';
  const last = lastName?.trim() || '';

  if (!first && !last) {
    return '';
  }

  if (!first) {
    return titleCase(last);
  }

  if (!last) {
    return titleCase(first);
  }

  return `${titleCase(first)} ${titleCase(last)}`;
};

export const convertToInitials = (text: string | null) => {
  if (!text) {
    return '';
  }
  const textParts = text.split(' ');
  const initials = textParts.map((name, index) => {
    if (index === textParts.length - 1) {
      return titleCase(name).charAt(0) + name.slice(1);
    }

    return titleCase(name).charAt(0) + '.';
  });

  return initials.join('');
};

export const titleCase = (text = '') =>
  text.toLowerCase().replace(/\b\w/g, c => c.toUpperCase());

export function kebabCase(string = '') {
  return string
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .toLowerCase();
}

export function removeSpaces(string = '') {
  return string.replace(/\s/g, '');
}

export function convertStringNumberToWords(number = '') {
  const ones = [
    '',
    'one',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
  ];
  const tens = [
    '',
    '',
    'twenty',
    'thirty',
    'forty',
    'fifty',
    'sixty',
    'seventy',
    'eighty',
    'ninety',
  ];
  const teens = [
    'ten',
    'eleven',
    'twelve',
    'thirteen',
    'fourteen',
    'fifteen',
    'sixteen',
    'seventeen',
    'eighteen',
    'nineteen',
  ];

  function convertMillions(number: number): string {
    if (number >= 1000000) {
      return (
        convertMillions(Math.floor(number / 1000000)) +
        ' million ' +
        convertThousands(number % 1000000)
      );
    } else {
      return convertThousands(number);
    }
  }

  function convertThousands(number: number) {
    if (number >= 1000) {
      return (
        convertHundreds(Math.floor(number / 1000)) +
        ' thousand ' +
        convertHundreds(number % 1000)
      );
    } else {
      return convertHundreds(number);
    }
  }

  function convertHundreds(number: number) {
    if (number > 99) {
      return (
        ones[Math.floor(number / 100)] + ' hundred ' + convertTens(number % 100)
      );
    } else {
      return convertTens(number);
    }
  }

  function convertTens(number: number) {
    if (number < 10) return ones[number];
    else if (number >= 10 && number < 20) return teens[number - 10];
    else {
      return tens[Math.floor(number / 10)] + ' ' + ones[number % 10];
    }
  }

  if (number === '' || number === '0' || Number.isNaN(number)) {
    return '';
  }

  return convertMillions(convertToNumber(number));
}

export const formatStringToNumber = (value: string | null): number => {
  if (!value) {
    return 0;
  }
  return +Number(value.replace(/(,|%)/g, '')).toFixed(2);
};

export function normalizePhoneNumber(phone: string) {
  // Remove all non-digit characters
  const digitsOnly = phone.replace(/\D/g, '');

  // If it starts with 1, prepend +, otherwise prepend +1
  if (digitsOnly.startsWith('1')) {
    return '+' + digitsOnly;
  } else {
    return '+1' + digitsOnly;
  }
}
